var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back-button'),_c('div',{staticClass:"flex-item_right"},[_c('event-summaries')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }